import { render, staticRenderFns } from "./uploadFbpClaims.vue?vue&type=template&id=d62fead0&scoped=true"
import script from "./uploadFbpClaims.vue?vue&type=script&lang=js"
export * from "./uploadFbpClaims.vue?vue&type=script&lang=js"
import style0 from "./uploadFbpClaims.vue?vue&type=style&index=0&id=d62fead0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d62fead0",
  null
  
)

export default component.exports